import { chakra, GridItem } from "@chakra-ui/react";
import { FundsOverviewCard } from "@/components/molecules/fundsOverviewCard";
import { CardProps } from "@/components/molecules/card/Card";

export interface FundsOverviewGridProps {
  cards: CardProps[];
}

export default chakra(FundsOverviewGrid);
function FundsOverviewGrid({ cards }: FundsOverviewGridProps) {
  return cards.map((cardProps, index) => (
    <GridItem
      key={cardProps.id}
      colSpan={{
        base: 12,
        lg: index < 3 ? 12 : 6,
        "3xl": index < 3 ? 12 : 4,
      }}
    >
      <FundsOverviewCard index={index} card={cardProps} />
    </GridItem>
  ));
}
